/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AgencyGroupFormConfiguration,
    AgencyGroupFormConfigurationFromJSON,
    AgencyGroupFormConfigurationToJSON,
    AgencyGroupFormData,
    AgencyGroupFormDataFromJSON,
    AgencyGroupFormDataToJSON,
    AgencyGroupFormValidationData,
    AgencyGroupFormValidationDataFromJSON,
    AgencyGroupFormValidationDataToJSON,
    AgencyGroupFormWarningsData,
    AgencyGroupFormWarningsDataFromJSON,
    AgencyGroupFormWarningsDataToJSON,
    ImportDataResponse,
    ImportDataResponseFromJSON,
    ImportDataResponseToJSON,
} from '../models';

export interface ApiAgencyGroupFormCreatePostRequest {
    agencyGroupFormData?: AgencyGroupFormData;
}

export interface ApiAgencyGroupFormDataGetRequest {
    id?: string;
}

export interface ApiAgencyGroupFormUpdatePostRequest {
    agencyGroupFormData?: AgencyGroupFormData;
}

export interface ApiAgencyGroupFormValidatePostRequest {
    agencyGroupFormData?: AgencyGroupFormData;
}

export interface ApiAgencyGroupFormWarningsPostRequest {
    agencyGroupFormData?: AgencyGroupFormData;
}

/**
 * no description
 */
export class AgencyGroupFormApi extends runtime.BaseAPI {

    /**
     */
    async apiAgencyGroupFormConfigurationGetRaw(): Promise<runtime.ApiResponse<AgencyGroupFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyGroupFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyGroupFormConfigurationGet(): Promise<AgencyGroupFormConfiguration> {
        const response = await this.apiAgencyGroupFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiAgencyGroupFormCreatePostRaw(requestParameters: ApiAgencyGroupFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyGroupFormDataToJSON(requestParameters.agencyGroupFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiAgencyGroupFormCreatePost(requestParameters: ApiAgencyGroupFormCreatePostRequest): Promise<string> {
        const response = await this.apiAgencyGroupFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAgencyGroupFormDataGetRaw(requestParameters: ApiAgencyGroupFormDataGetRequest): Promise<runtime.ApiResponse<AgencyGroupFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyGroupFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyGroupFormDataGet(requestParameters: ApiAgencyGroupFormDataGetRequest): Promise<AgencyGroupFormData> {
        const response = await this.apiAgencyGroupFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAgencyGroupFormImportPostRaw(): Promise<runtime.ApiResponse<ImportDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupForm/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyGroupFormImportPost(): Promise<ImportDataResponse> {
        const response = await this.apiAgencyGroupFormImportPostRaw();
        return await response.value();
    }

    /**
     */
    async apiAgencyGroupFormUpdatePostRaw(requestParameters: ApiAgencyGroupFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyGroupFormDataToJSON(requestParameters.agencyGroupFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAgencyGroupFormUpdatePost(requestParameters: ApiAgencyGroupFormUpdatePostRequest): Promise<void> {
        await this.apiAgencyGroupFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiAgencyGroupFormValidatePostRaw(requestParameters: ApiAgencyGroupFormValidatePostRequest): Promise<runtime.ApiResponse<AgencyGroupFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyGroupFormDataToJSON(requestParameters.agencyGroupFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyGroupFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyGroupFormValidatePost(requestParameters: ApiAgencyGroupFormValidatePostRequest): Promise<AgencyGroupFormValidationData> {
        const response = await this.apiAgencyGroupFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAgencyGroupFormWarningsPostRaw(requestParameters: ApiAgencyGroupFormWarningsPostRequest): Promise<runtime.ApiResponse<AgencyGroupFormWarningsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupForm/Warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyGroupFormDataToJSON(requestParameters.agencyGroupFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyGroupFormWarningsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyGroupFormWarningsPost(requestParameters: ApiAgencyGroupFormWarningsPostRequest): Promise<AgencyGroupFormWarningsData> {
        const response = await this.apiAgencyGroupFormWarningsPostRaw(requestParameters);
        return await response.value();
    }

}
